import { findLastIndex } from "lodash";
import axios from "axios";
axios.defaults.baseURL =
  "https://qr-menu.outsystemscloud.com/Menu/rest/QRMenuServer/";
import _ from "lodash";
export default {
  namespaced: true,
  state: {
    tables: [],
    timeSlots: [],
    availablePaymentTypes: [],

    newOrder: sessionStorage.getItem("orderChunksExists"),
    orderId: "",
    customerId: "",
    tableId: 0,
    paymentTypeId: 1,
    securityCode: "",
    selectedTimeSlot: "",
    processBarCurrentItem: 1,
    homeDelivery: false,
    customer: {
      fullName: "",
      email: "",
      phone: "",
    },
    note: "",

    cartValue: 0,
    totalPriceValue: 0,
    totalPriceValueWithCosts: 0,
    totalPriceValueWithCostsValue: 0,
    tipAmount: 0,
    extraChargeAmount: 0,
    numberOfGuests: 0,
    discountCode: "",
    discountAmount: 0,
    discountDecimalValue: 0,
    isDiscountCodeCorrect: true,
    discountPercentageValue: 0,
    homeDeliveryCosts: 0,
    discountInfo: {},
    // cartAdditions: 0,
    items: [],
  },
  mutations: {
    addItem(state, data) {
      state.items.push(data);
      state.cartValue += data.price;
      if (data.OrderItemAdditions) {
        // console.log(Object.keys(data.OrderItemAdditions).length)
        for (let i = 0; i < Object.keys(data.OrderItemAdditions).length; i++) {
          // console.log(data.OrderItemAdditions[i]['Addition']['price'])
          state.cartValue += data.OrderItemAdditions[i]["Addition"]["price"];
        }
      }
    },
    removeItem(state, data) {
      let index = findLastIndex(state.items, data);
      if (index >= 0) {
        state.items.splice(index, 1);
        state.cartValue -= data.price + state.cartAdditions;
      }
    },
    /**
     * Ideally we should utilise the the above "removeItem" mutation but somehow
     * calling mutation recusively throwin error.
     * Having recursive way to remove multiple items is good here but, for now
     * a plural named "removeItems" mutation added which will remove multiple items from cart.
     *
     * @param {state} state
     * @param {data} item
     *
     * @return void
     */
    removeItems(state, data) {
      state.items.forEach(() => {
        let index = findLastIndex(state.items, data);
        if (index >= 0) {
          state.items.splice(index, 1);
          state.cartValue -= data.price + state.cartAdditions;
        }
      });
    },
    // addCartAdditions(state, value) {
    //   state.cartAdditions += value
    // },
    // subtractCartAdditions(state, value) {
    //   state.cartAdditions -= value
    // },
    emptyCart(state) {
      state.items = [];
    },
    updateTables(state, data) {
      state.tables = data;
    },
    updateTableId(state, tableId) {
      state.tableId = tableId;
    },
    updateTimeSlots(state, data) {
      state.timeSlots = data;
    },
    updateDiscountInfo(state, data) {
      state.discountInfo = data;
    },
    updateSelectedTimeSlot(state, timeSlot) {
      state.selectedTimeSlot = timeSlot;
    },
    updateCustomerId(state, Id) {
      state.customerId = Id;
    },
    updateOrderId(state, Id) {
      state.orderId = Id;
    },
    updateCustomer(state, data) {
      state.customer[data.field] = data.value;
    },
    updateNote(state, note) {
      state.note = note;
    },
    updateAvailablePaymentTypes(state, data) {
      state.availablePaymentTypes = data;
    },
    updatePaymentTypeId(state, paymentTypeId) {
      state.paymentTypeId = paymentTypeId;
    },
    removeOrderChunks() {
      sessionStorage.removeItem("orderChunksExists");
    },
    updateSecurityCode(state, code) {
      state.securityCode = code;
    },
    updateTotalPriceValue(state, value) {
      state.totalPriceValue = value;
    },
    updateTotalPriceValueWithCost(state, value) {
      state.totalPriceValue = value;
    },
    updateTipAmount(state, value) {
      if (state.tipAmount + value >= 0) {
        state.tipAmount += value;
      }
    },
    updateExtraChargeAmount(state, value) {
      state.extraChargeAmount = value;
    },
    updateNumberOfGuests(state, value) {
      if (state.numberOfGuests + value >= 0) {
        state.numberOfGuests += value;
      }
    },
    updateIsDiscountCodeCorrect(state, value) {
      state.isDiscountCodeCorrect = value;
    },
    updateDiscountPercentageValue(state, value) {
      state.discountPercentageValue = value;
    },
    updateDiscountDecimalValue(state, value) {
      state.discountDecimalValue = value;
    },
    updateDiscountCode(state, value) {
      state.discountCode = value;
    },
    updateHomeDelivery(state) {
      state.homeDelivery = !state.homeDelivery;
    },
    updateHomeDeliveryCosts(state, value) {
      state.homeDeliveryCosts = value;
    },
  },
  actions: {
    UPDATE_ORDER({ commit, state, rootState, getters, rootGetters }, data) {
      let method,
        endpoint = "";

      if (sessionStorage.getItem("orderChunksExists") === null) {
        sessionStorage.setItem("orderChunksExists", true);
        method = "post";
        endpoint = "https://q4-api.qr-menu.app/api/PostOrder";
      } else {
        method = "put";
        endpoint = "https://q4-api.qr-menu.app/api/PatchOrder";
      }

      if (data) {
        if (data.operation == "add") {
          commit("addItem", data.item);
        } else {
          commit("removeItem", data.item);
        }
      }

      return new Promise((resolve, reject) => {
        let formData = {
          TableId: state.tableId,
          PaymentTypeId: state.paymentTypeId,
          MenuHASH: rootState.menuHash,
          OrderItems: getters.cartItemsRestructred,
          Customer: state.customer,
          sessionId: rootGetters.sessionId,
          SecurityToken: state.securityCode,
          note: state.note,
          tip_amount: state.tipAmount,
          number_of_guests: state.numberOfGuests,
          discountCode: state.discountCode,
        };
        if (
          getters.totalPriceValue + state.tipAmount >=
          rootState.menu.min_spent
        ) {
          formData.extra_charge_amount = 0;
        } else {
          formData.extra_charge_amount = state.extraChargeAmount;
        }

        if (
          state.selectedTimeSlot &&
          (rootState.menu.timeslots_mode == "general" ||
            rootState.menu.timeslots_mode == "individual")
        ) {
          formData["deliveryDateTime"] = state.selectedTimeSlot;
        }
        if (rootState.menu.enable_delivery && rootState.Cart.homeDelivery) {
          formData.tip_amount += state.homeDeliveryCosts;
          formData.delivery_cost = state.homeDeliveryCosts;
          formData.delivery_address1 = rootState.address;
          formData.delivery_city = rootState.city;
          formData.delivery_zip = rootState.zip;
          formData.delivery_country = rootState.country;
        }
        axios({
          method: method,
          url: endpoint,
          data: formData,
        })
          .then((response) => {
            commit("updateCustomerId", response.data.OrderAPI.CustomerId);
            commit("updateOrderId", response.data.OrderAPI.orderId);

            commit("emptyCart");
            response.data.OrderAPI.OrderItems.forEach((element) => {
              let menuItem = element.MenuItem;
              menuItem["OrderItemAdditions"] = element.OrderItemAdditions;
              commit("addItem", menuItem);
            });
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GET_TABLES({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`GetTablesOrdering2?MenuHash=${rootState.menuHash}`)
          .then((response) => {
            commit("updateTables", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    GET_TIME_SLOTS({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`GetTimeSlotsOrdering2?MenuHash=${rootState.menuHash}`)
          .then((response) => {
            commit("updateTimeSlots", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GET_MENU_ITEM_ORDERING({ rootState }, menuItemId) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `https://q4-api.qr-menu.app/api/GetMenuItemOrdering?MenuHash=${rootState.menuHash}&CategoryId=${rootState.categoryId}&MenuItemId=${menuItemId}`
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    INITIATE_TRANSACTION({ state, rootState, rootGetters }, paymentTypeId) {
      let tableId = localStorage.getItem("stickerId")
        ? localStorage.getItem("stickerId")
        : state.tableId;
      return new Promise((resolve, reject) => {
        axios
          .get(
            `InitiateTransaction2?sessionId=${rootGetters.sessionId}&orderId=${state.orderId}&paymentTypeId=${paymentTypeId}&returnUrl=${rootState.appUrl}/${rootState.menuHash}/${tableId}/order-details?sessionId=${rootGetters.sessionId}`
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    VALIDATE_DISCOUNT_CODE({ commit, rootState }, discountCode) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `ValidateDiscountCode?MenuHash=${rootState.menuHash}&Code=${discountCode}`
          )
          .then((response) => {
            if (response.data.length != 0) {
              commit("updateDiscountInfo", response.data[0]);
            } else {
              commit("updateDiscountInfo", "");
            }
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
  },
  getters: {
    cartItems: (state) => state.items,
    cartItemsRestructred: (state) => {
      let orderItems = [];
      for (let i = 0; i < state.items.length; i++) {
        // console.log('state items', state.items[i])
        /** Restructing orderModifiers as the backend expects */
        let orderItemAdditions = [];
        _.forEach(state.items[i]["OrderItemAdditions"], function (value) {
          // console.log('each item', value)
          orderItemAdditions.push({
            AdditionGroupId: value["Addition"]["AdditionGroupId"],
            AdditionId: value["Addition"]["Id"],
          });
        });
        // console.log(orderItemAdditions)
        /** Fuliflling backend's expectations */
        orderItems.push({
          MenuItemId: state.items[i]["Id"],
          OrderItemAdditions: orderItemAdditions,
        });
      }
      return orderItems;
    },
    cartValue: (state, getters, rootState) => {
      let totalPrice = 0;
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      return (state.cartValue = new Intl.NumberFormat(
        rootState.languageLocales[rootState.language].locale,
        {
          style: "currency",
          currency: rootState.languageLocales[rootState.language].currency,
        }
      )
        .formatToParts(totalPrice)
        .map(({ type, value }) => {
          switch (type) {
            case "currency":
              return `${rootState.currency}`;
            default:
              return value;
          }
        })
        .reduce((string, part) => string + part));
    },
    tables: (state) => state.tables,
    timeSlots: (state) => state.timeSlots,
    discountInfo: (state) => state.discountInfo,
    selectedTimeSlot: (state) => state.selectedTimeSlot,
    customerId: (state) => state.customerId,
    tableId: (state) => state.tableId,
    customer: (state) => state.customer,
    note: (state) => state.note,
    availablePaymentTypes: (state) => state.availablePaymentTypes,
    securityCode: (state) => state.securityCode,
    isListDisplayed: (state) => state.isListDisplayed,
    totalPriceValue: (state) => {
      let totalPrice = 0;
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      return (state.totalPriceValue = totalPrice);
    },
    totalPriceValueWithCosts: (state, getters, rootState) => {
      let totalPrice = 0;
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      if (rootState.menu.enable_tipping) {
        totalPrice += state.tipAmount;
      }
      if (totalPrice < rootState.menu.min_spent_amount_w_charg) {
        totalPrice += rootState.menu.charge_amount_when_min_spent;
      }
      if (
        state.discountInfo.is_active &&
        state.items.length >= state.discountInfo.minimum_items &&
        state.totalPriceValue + state.tipAmount >=
          state.discountInfo.minimum_spent
      ) {
        totalPrice -= state.discountAmount;
      }
      if (state.homeDelivery) {
        totalPrice += state.homeDeliveryCosts;
      }
      return (state.totalPriceValueWithCosts = new Intl.NumberFormat(
        rootState.languageLocales[rootState.language].locale,
        {
          style: "currency",
          currency: rootState.languageLocales[rootState.language].currency,
        }
      )
        .formatToParts(totalPrice)
        .map(({ type, value }) => {
          switch (type) {
            case "currency":
              return `${rootState.currency}`;
            default:
              return value;
          }
        })
        .reduce((string, part) => string + part));
    },
    totalPriceValueWithCostsValue: (state, getters, rootState) => {
      let totalPrice = 0;
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      if (rootState.menu.enable_tipping) {
        totalPrice += state.tipAmount;
      }
      if (totalPrice < rootState.menu.min_spent_amount_w_charg) {
        totalPrice += rootState.menu.charge_amount_when_min_spent;
      }
      if (
        state.discountInfo.is_active &&
        state.items.length >= state.discountInfo.minimum_items &&
        state.totalPriceValue + state.tipAmount >=
          state.discountInfo.minimum_spent
      ) {
        totalPrice -= state.discountAmount;
      }
      if (state.homeDelivery) {
        totalPrice += state.homeDeliveryCosts;
      }
      return (state.totalPriceValueWithCostsValue = totalPrice);
    },
    tipAmount: (state) => state.tipAmount,
    extraChargeAmount: (state) => state.extraChargeAmount,
    numberOfGuests: (state) => state.numberOfGuests,
    discountDecimalValue: (state) => state.discountDecimalValue,
    isDiscountCodeCorrect: (state) => state.isDiscountCodeCorrect,
    discountPercentageValue: (state) => state.discountPercentageValue,
    discountAmount: (state) => {
      if (state.discountInfo.type === "Percentage") {
        //Check if we don't reach the maximum amount discount, else give the maximum border
        state.discountAmount =
          (state.totalPriceValue * state.discountInfo.value) / 100;

        if (
          state.discountAmount >=
            state.discountInfo.max_disc_amount_percentage &&
          state.discountInfo.max_disc_amount_percentage != 0
        ) {
          state.discountAmount = state.discountInfo.max_disc_amount_percentage;
        }
      } else {
        state.discountAmount = state.discountInfo.value;
      }
      return state.discountAmount;
    },
    discountCode: (state) => state.discountCode,
    homeDelivery: (state) => state.homeDelivery,
    homeDeliveryCosts: (state) => state.homeDeliveryCosts,
  },
};
